export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "helpTranslate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Help translate Data Pulse"])}
      }
    }
  })
}
